/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";
import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import Modal from "@mui/material/Modal";
import Slide from "@mui/material/Slide";

import Stack from "@mui/material/Stack";

// @mui icons
import CloseIcon from "@mui/icons-material/Close";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function Faq() {
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);

  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="white"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h2">COMMON QUESTIONS</MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">What services do you offer?</MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    We provide plumbing, sanitary, electrical, and general repair works for
                    residential and commercial properties.
                  </MKTypography>
                </MKBox>
              </Grid>
            </Grid>
            <Divider style={{ background: "black" }} sx={{ mt: "4", mb: 0 }} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">Do you charge for site visits?</MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    Site visits for quotations are FOC (Free of Charge)
                  </MKTypography>
                </MKBox>
              </Grid>
            </Grid>
            <Divider style={{ background: "black" }} sx={{ mt: "4", mb: 0 }} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">
                    What warranties do you offer for your services, and what do they cover?
                  </MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    New project/renovation warranty: 3 years <br />
                    Servicing/Maintenance warranty: 1 year <br />
                    <Link to="#" onClick={toggleModal}>
                      Terms & Conditions apply
                    </Link>
                  </MKTypography>
                </MKBox>
              </Grid>
            </Grid>
            <Divider style={{ background: "black" }} sx={{ mt: "4", mb: 0 }} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <MKBox mb={1}>
                  <MKTypography variant="h4">How can I contact you?</MKTypography>
                </MKBox>
              </Grid>

              <Grid item xs={12} lg={6}>
                <MKBox mb={1} pr={2}>
                  <MKTypography variant="body2" color="text">
                    You can reach us via phone call or WhatsApp. We’ll respond as quickly as
                    possible to assist you.
                  </MKTypography>
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Modal open={show} onClose={toggleModal} sx={{ display: "grid", placeItems: "center" }}>
        <Slide direction="down" in={show} timeout={500}>
          <MKBox
            position="relative"
            width="80%"
            display="flex"
            flexDirection="column"
            borderRadius="xl"
            bgColor="white"
            shadow="xl"
          >
            <MKBox display="flex" alignItems="center" justifyContent="space-between" p={2}>
              <MKTypography variant="h5">Terms & Conditions</MKTypography>
              <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={toggleModal} />
            </MKBox>
            <Divider sx={{ my: 0 }} />
            <MKBox
              p={2}
              px={{ lg: 4 }}
              sx={{
                height: "600px",
                overflow: "scroll",
              }}
            >
              <MKTypography variant="body" fontWeight="regular">
                Warranty for New Projects / Renovations (3 Years)
              </MKTypography>
              <MKTypography variant="body2" fontWeight="regular">
                Coverage: <br />
                <MKBox component="li" pl={4}>
                  All water supply and outlet piping
                </MKBox>
                <MKBox component="li" pl={4}>
                  Installation of toilet sanitary ware only
                </MKBox>
                Exclusions:
                <MKBox component="li" pl={4}>
                  Normal wear and tear, including but not limited to:
                </MKBox>
                <Stack component="ol" pl={10}>
                  <MKBox component="li">Faulty sanitary ware</MKBox>

                  <MKBox component="li">Mold or silicone degradation</MKBox>
                </Stack>
                <MKBox component="li" pl={4}>
                  Replacement or repair work performed by third parties (not by our company)
                </MKBox>
                <MKBox component="li" pl={4}>
                  Clogs in outlet pipes, including but not limited to:
                </MKBox>
                <Stack component="ol" pl={10}>
                  <MKBox component="li">Toilet bowl</MKBox>
                  <MKBox component="li">Basin</MKBox>
                  <MKBox component="li">Floor waste</MKBox>
                  <MKBox component="li">Floor trap</MKBox>
                </Stack>
                <br />
              </MKTypography>
              <MKTypography variant="body" fontWeight="regular">
                Servicing / Maintenance Warranty
              </MKTypography>
              <MKTypography variant="body2" fontWeight="regular">
                Coverage:
                <MKBox component="li" pl={4}>
                  All water supply and outlet piping
                </MKBox>
                <MKBox component="li" pl={4}>
                  Installation of toilet sanitary ware only
                </MKBox>
                Exclusions:
                <MKBox component="li" pl={4}>
                  Normal wear and tear, including but not limited to:
                </MKBox>
                <Stack component="ol" pl={10}>
                  <MKBox component="li">Faulty sanitary ware</MKBox>
                  <MKBox component="li">Mold or silicone degradation</MKBox>
                </Stack>
                <MKBox component="li" pl={4}>
                  Replacement or repair work performed by third parties (not by our company)
                </MKBox>
                <MKBox component="li" pl={4}>
                  Clogs in outlet pipes, including but not limited to:
                </MKBox>
                <Stack component="ol" pl={10}>
                  <MKBox component="li">Toilet bowl</MKBox>
                  <MKBox component="li">Basin</MKBox>
                  <MKBox component="li">Floor waste</MKBox>
                  <MKBox component="li">Floor trap</MKBox>
                </Stack>
                <br />
              </MKTypography>
              <MKTypography variant="body" fontWeight="regular">
                Warranty Claims Procedure
              </MKTypography>
              <MKTypography variant="body2" fontWeight="regular">
                <MKBox component="li" pl={4}>
                  For all warranty claims, please provide the following information:
                </MKBox>
                <Stack component="ol" pl={10}>
                  <MKBox component="li">Date of service or completion of renovation</MKBox>
                  <MKBox component="li">Invoice number</MKBox>
                  <MKBox component="li">Address of repair/end of renovation site</MKBox>
                </Stack>
                <MKBox component="li" pl={4}>
                  An appointment will be scheduled for an inspection.
                </MKBox>
                <MKBox component="li" pl={4}>
                  If the issue falls within the warranty coverage, the service will be provided free
                  of charge (FOC). For issues outside the warranty scope, repair and transportation
                  fees will be charged.
                </MKBox>
              </MKTypography>
            </MKBox>
            <Divider sx={{ my: 0 }} />
            <MKBox display="flex" justifyContent="space-between" p={1.5}>
              <MKButton variant="gradient" color="dark" onClick={toggleModal}>
                close
              </MKButton>
            </MKBox>
          </MKBox>
        </Slide>
      </Modal>
    </MKBox>
  );
}

export default Faq;
